import { updateStageCampanha } from "./updateStageCampanha";
import state from "../../vuex/state";

export const recalculateHubPromotionsCounters = (
  hubPromotions = [],
  campanhasDisponiveis = []
) => {
  const counters = {
    acquired: 0,
    partial: 0,
    notAcquired: 0,
  };

  // Se não há promoções do hub, retorna contadores zerados
  if (!hubPromotions || hubPromotions.length === 0) {
    return counters;
  }

  // Cria um mapa de campanhas por code/id para busca rápida
  const campanhasMap = new Map();
  campanhasDisponiveis.forEach((campanha) => {
    const campanhaId = String(campanha.id || campanha.code || "");
    if (campanhaId) {
      campanhasMap.set(campanhaId, campanha);
    }
  });

  // Processa cada promoção do hub
  hubPromotions.forEach((hubPromo) => {
    const campanhaId = String(hubPromo.code || "");
    const campanha = campanhasMap.get(campanhaId);

    // Se não encontrou a campanha correspondente, mantém o status original
    if (!campanha) {
      // Mantém o status original do hub
      if (hubPromo.status === "acquired") counters.acquired++;
      else if (hubPromo.status === "partial") counters.partial++;
      else counters.notAcquired++;
      return;
    }

    // Garante que a campanha tenha os dados necessários para updateStageCampanha
    if (!campanha.produtos_anteriores) {
      campanha.produtos_anteriores = {};
    }
    if (!campanha.situacao_credito) {
      campanha.situacao_credito = [];
    }

    // Calcula o status da campanha baseado no carrinho atual
    let campanhaStatus;
    try {
      campanhaStatus = updateStageCampanha(campanha);
    } catch (error) {
      console.warn("Erro ao calcular status da campanha:", error);
      counters.notAcquired++;
      return;
    }
    
    if (!campanhaStatus) {
      counters.notAcquired++;
      return;
    }

    // Determina o status baseado no percentAtual
    const percentAtual = campanhaStatus.percentAtual || 0;

    if (percentAtual >= 100) {
      // Campanha totalmente ativada
      counters.acquired++;
    } else if (percentAtual > 0) {
      // Campanha parcialmente ativada
      counters.partial++;
    } else {
      // Campanha não iniciada
      counters.notAcquired++;
    }
  });

  return counters;
};

export const updateHubPromotionsStatus = (
  hubPromotions = [],
  campanhasDisponiveis = []
) => {
  if (!hubPromotions || hubPromotions.length === 0) {
    return [];
  }

  // Cria um mapa de campanhas por code/id
  const campanhasMap = new Map();
  campanhasDisponiveis.forEach((campanha) => {
    const campanhaId = String(campanha.id || campanha.code || "");
    if (campanhaId) {
      campanhasMap.set(campanhaId, campanha);
    }
  });

  // Atualiza o status de cada promoção
  return hubPromotions.map((hubPromo) => {
    const campanhaId = String(hubPromo.code || "");
    const campanha = campanhasMap.get(campanhaId);

    // Se não encontrou a campanha, mantém o status original
    if (!campanha) {
      return { ...hubPromo };
    }

    // Garante que a campanha tenha os dados necessários
    if (!campanha.produtos_anteriores) {
      campanha.produtos_anteriores = {};
    }
    if (!campanha.situacao_credito) {
      campanha.situacao_credito = [];
    }

    // Calcula o novo status
    let campanhaStatus;
    try {
      campanhaStatus = updateStageCampanha(campanha);
    } catch (error) {
      console.warn("Erro ao calcular status da campanha:", error);
      return { ...hubPromo, status: "notAcquired" };
    }
    
    if (!campanhaStatus) {
      return { ...hubPromo, status: "notAcquired" };
    }

    const percentAtual = campanhaStatus.percentAtual || 0;
    let newStatus = "notAcquired";

    if (percentAtual >= 100) {
      newStatus = "acquired";
    } else if (percentAtual > 0) {
      newStatus = "partial";
    }

    return { ...hubPromo, status: newStatus };
  });
};

